const STATUS_TITLES: Record<string, string> = {
  draft: 'Черновик',
  submitted: 'Ожидание оплаты',
  executed: 'Оплачено',
  overdued: 'Просрочен',
};

export const getPaymentStatusTitle = (status: string) => STATUS_TITLES[status.toLowerCase()] || status;
